import { IntentType } from '@40seas/entities/intents';
import jwt_decode from 'jwt-decode';
import { convertStringToEnumValue } from './layoutStrategyManager';
import { DashboardModalConfig, LayoutStrategyProvider, LayoutStrategyProviderParams } from './layoutStrategyProvider';
import { GUEST_PORTAL_INTENTS } from './consts';

export class GenericModalStrategyProvider implements LayoutStrategyProvider {
    constructor(private readonly params: LayoutStrategyProviderParams) {}

    shouldApply = (): boolean => {
        const { urlToken } = this.params;
        if (!urlToken) return false;

        const decodedData = jwt_decode<{ intentType: string; guestPortal: boolean }>(urlToken);
        const intentType = convertStringToEnumValue(decodedData.intentType);

        if (!intentType) return false;

        return !GUEST_PORTAL_INTENTS.includes(intentType);
    };

    openModal = (): DashboardModalConfig => {
        const { urlToken } = this.params;

        if (!urlToken) throw new Error('Unable to open modal, no token provided');

        const intent = jwt_decode<{ intentType: string }>(urlToken);
        const intentType = convertStringToEnumValue(intent.intentType) || IntentType.Signup;

        return { intentType, token: urlToken };
    };
}
